import { useData } from './contexts/DataContext';
import { useLanguage } from './contexts/LanguageContext';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import Header from './components/General/Header';
import Footer from './components/General/Footer';

const Layout = () => {
  const { t } = useTranslation();
  const { language } = useLanguage();
  const result = useData();
  const isRTL = language === 'ar';

  if (!result.data) {
    return null;
  }

  return (
    <div className="overflow-hidden">
      <Header
        siteData={result.data}
        isRTL={isRTL}
        t={t}
      />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
